import {rpAppLink} from "@pg-mono/rp-routes";

import {IHomematchPreleadListItem} from "../../homematch_tinder/types/IHomematchPrelead";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {
    PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
    PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES
} from "../constants/personalized_homepage_mocks";
import {IPersonalizedPropertyCard, IPersonalizedRecentSearch, IPersonalizedRecommendationsTeaser} from "../types/IPersonalizedHomepage";

const PREVIEWS_LIMIT = 3;
const PREVIEW_THUMBNAIL_WIDTH = 375;
const PREVIEW_THUMBNAIL_HEIGHT = 484;

interface IParams {
    /** Pending Homematch tinder preleads (RP-830) — the primary teaser source. */
    homematchPreleads: IHomematchPreleadListItem[];
    recentSearches: IPersonalizedRecentSearch[];
    recentlyViewedProperties: IPersonalizedPropertyCard[];
}

/**
 * The teaser prefers the real Homematch buffer (count, previews and badge from
 * pending preleads). Without one — kill switch, cold start, no data yet — it
 * degrades to the offers the user actually browsed, and finally to static
 * previews. The CTA replays the newest search on the RP listing either way:
 * the tinder deck has no RP entry point yet (RP-775).
 */
export const getPersonalizedRecommendationsTeaser = (params: IParams): IPersonalizedRecommendationsTeaser => {
    const homematchTeaser = getHomematchTeaser(params);

    if (homematchTeaser) {
        return homematchTeaser;
    }

    const viewedWithImages = params.recentlyViewedProperties
        .filter((property) => Boolean(property.imageUrl))
        .filter((property, index, allProperties) => allProperties.findIndex((candidate) => candidate.imageUrl === property.imageUrl) === index)
        .slice(0, PREVIEWS_LIMIT);
    const topViewedProperty = viewedWithImages[0];
    // The stack renders back-to-front, so the newest viewed offer goes last (fully visible).
    const imageUrls = topViewedProperty
        ? [
              ...PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES.slice(0, PREVIEWS_LIMIT - viewedWithImages.length),
              ...viewedWithImages.map((property) => property.imageUrl).reverse()
          ]
        : PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES;
    const hasBrowserData = Boolean(topViewedProperty) || params.recentSearches.length > 0;

    return {
        imageUrls,
        offersCount: null,
        badgeLabel: topViewedProperty ? topViewedProperty.offerName : PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
        href: getTeaserHref(params),
        source: hasBrowserData ? "browser" : "mock"
    };
};

const getHomematchTeaser = (params: IParams): IPersonalizedRecommendationsTeaser | null => {
    const preleadsWithImages = params.homematchPreleads
        .map((prelead) => ({prelead, imageUrl: getPreleadImageUrl(prelead)}))
        .filter((preleadWithImage): preleadWithImage is {prelead: IHomematchPreleadListItem; imageUrl: string} => preleadWithImage.imageUrl !== null)
        .filter((preleadWithImage, index, allPreleads) => allPreleads.findIndex((candidate) => candidate.imageUrl === preleadWithImage.imageUrl) === index)
        .slice(0, PREVIEWS_LIMIT);
    // The badge names the fully visible photo; without any photo it names the newest prelead.
    const topPrelead = preleadsWithImages[0]?.prelead ?? params.homematchPreleads[0];

    if (!topPrelead) {
        return null;
    }

    return {
        // Back-to-front stack: the newest prelead ends up as the fully visible photo.
        imageUrls: [
            ...PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES.slice(0, PREVIEWS_LIMIT - preleadsWithImages.length),
            ...preleadsWithImages.map((preleadWithImage) => preleadWithImage.imageUrl).reverse()
        ],
        offersCount: params.homematchPreleads.length,
        badgeLabel: topPrelead.property.offer?.name || PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
        href: getTeaserHref(params),
        source: "api"
    };
};

const getPreleadImageUrl = (prelead: IHomematchPreleadListItem): string | null => {
    const propertyImage = prelead.property.images?.[0];
    const offerImage = prelead.property.offer?.images?.[0];
    const offerThumbnails = prelead.property.offer?.main_image;

    return (
        getThumbnailLink(propertyImage?.source_image_url, PREVIEW_THUMBNAIL_WIDTH, PREVIEW_THUMBNAIL_HEIGHT) ||
        getThumbnailLink(offerImage?.source_image_url, PREVIEW_THUMBNAIL_WIDTH, PREVIEW_THUMBNAIL_HEIGHT) ||
        propertyImage?.thumbnails?.g_img_500 ||
        propertyImage?.thumbnails?.g_img_750 ||
        offerThumbnails?.m_img_500 ||
        offerThumbnails?.m_img_750 ||
        null
    );
};

const getTeaserHref = (params: IParams): string => params.recentSearches[0]?.href || rpAppLink.offer.list();
import {rpAppLink} from "@pg-mono/rp-routes";

import {IHomematchPreleadListItem} from "../../homematch_tinder/types/IHomematchPrelead";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {
    PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
    PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES
} from "../constants/personalized_homepage_mocks";
import {IPersonalizedPropertyCard, IPersonalizedRecentSearch, IPersonalizedRecommendationsTeaser} from "../types/IPersonalizedHomepage";

const PREVIEWS_LIMIT = 3;
const PREVIEW_THUMBNAIL_WIDTH = 375;
const PREVIEW_THUMBNAIL_HEIGHT = 484;

interface IParams {
    /** Pending Homematch tinder preleads (RP-830) — the primary teaser source. */
    homematchPreleads: IHomematchPreleadListItem[];
    recentSearches: IPersonalizedRecentSearch[];
    recentlyViewedProperties: IPersonalizedPropertyCard[];
}

/**
 * The teaser prefers the real Homematch buffer (count, previews and badge from
 * pending preleads). Without one — kill switch, cold start, no data yet — it
 * degrades to the offers the user actually browsed, and finally to static
 * previews. The CTA replays the newest search on the RP listing either way:
 * the tinder deck has no RP entry point yet (RP-775).
 */
export const getPersonalizedRecommendationsTeaser = (params: IParams): IPersonalizedRecommendationsTeaser => {
    const homematchTeaser = getHomematchTeaser(params);

    if (homematchTeaser) {
        return homematchTeaser;
    }

    const viewedWithImages = params.recentlyViewedProperties
        .filter((property) => Boolean(property.imageUrl))
        .filter((property, index, allProperties) => allProperties.findIndex((candidate) => candidate.imageUrl === property.imageUrl) === index)
        .slice(0, PREVIEWS_LIMIT);
    const topViewedProperty = viewedWithImages[0];
    // The stack renders back-to-front, so the newest viewed offer goes last (fully visible).
    const imageUrls = topViewedProperty
        ? [
              ...PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES.slice(0, PREVIEWS_LIMIT - viewedWithImages.length),
              ...viewedWithImages.map((property) => property.imageUrl).reverse()
          ]
        : PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES;
    const hasBrowserData = Boolean(topViewedProperty) || params.recentSearches.length > 0;

    return {
        imageUrls,
        offersCount: null,
        badgeLabel: topViewedProperty ? topViewedProperty.offerName : PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
        href: getTeaserHref(params),
        source: hasBrowserData ? "browser" : "mock"
    };
};

const getHomematchTeaser = (params: IParams): IPersonalizedRecommendationsTeaser | null => {
    const preleadsWithImages = params.homematchPreleads
        .map((prelead) => ({prelead, imageUrl: getPreleadImageUrl(prelead)}))
        .filter((preleadWithImage): preleadWithImage is {prelead: IHomematchPreleadListItem; imageUrl: string} => preleadWithImage.imageUrl !== null)
        .filter((preleadWithImage, index, allPreleads) => allPreleads.findIndex((candidate) => candidate.imageUrl === preleadWithImage.imageUrl) === index)
        .slice(0, PREVIEWS_LIMIT);
    // The badge names the fully visible photo; without any photo it names the newest prelead.
    const topPrelead = preleadsWithImages[0]?.prelead ?? params.homematchPreleads[0];

    if (!topPrelead) {
        return null;
    }

    return {
        // Back-to-front stack: the newest prelead ends up as the fully visible photo.
        imageUrls: [
            ...PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES.slice(0, PREVIEWS_LIMIT - preleadsWithImages.length),
            ...preleadsWithImages.map((preleadWithImage) => preleadWithImage.imageUrl).reverse()
        ],
        offersCount: params.homematchPreleads.length,
        badgeLabel: topPrelead.property.offer?.name || PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE,
        href: getTeaserHref(params),
        source: "api"
    };
};

const getPreleadImageUrl = (prelead: IHomematchPreleadListItem): string | null => {
    const propertyImage = prelead.property.images?.[0];
    const offerImage = prelead.property.offer?.images?.[0];
    const offerThumbnails = prelead.property.offer?.main_image;

    return (
        getThumbnailLink(propertyImage?.source_image_url, PREVIEW_THUMBNAIL_WIDTH, PREVIEW_THUMBNAIL_HEIGHT) ||
        getThumbnailLink(offerImage?.source_image_url, PREVIEW_THUMBNAIL_WIDTH, PREVIEW_THUMBNAIL_HEIGHT) ||
        propertyImage?.thumbnails?.g_img_500 ||
        propertyImage?.thumbnails?.g_img_750 ||
        offerThumbnails?.m_img_500 ||
        offerThumbnails?.m_img_750 ||
        null
    );
};

const getTeaserHref = (params: IParams): string => params.recentSearches[0]?.href || rpAppLink.offer.list();
